import * as yup from 'yup';
import {
  MAX_PLANT_SPACING,
  MAX_ROW_SPACING,
} from '../../../../services/entities/impl/blfApi/schemas/block';
import { CropTypes } from '../../../../services/entities/impl/blfApi/schemas/variety';

export const BlockFormSchemaIn = yup.object({
  id: yup.string(),
  name: yup.string().required('Name is required'),
  customerID: yup.string().required(), // Edge case for block creation, doesn't exist in the schema but needed to filter ranches
  ranchID: yup.string().required('Ranch ID is required'),
  acres: yup.number().positive('Acres must be a positive number').nullable(),
  cropType: yup
    .string()
    .oneOf(Object.values(CropTypes), 'Invalid crop type')
    .required('Crop type is required'),
  plantSpacing: yup
    .number()
    .positive('Plant spacing must be a positive number')
    .max(
      MAX_PLANT_SPACING,
      `Plant spacing must be less than ${MAX_PLANT_SPACING}`
    )
    .nullable(),
  rowSpacing: yup
    .number()
    .positive('Row spacing must be a positive number')
    .max(MAX_ROW_SPACING, `Row spacing must be less than ${MAX_ROW_SPACING}`)
    .nullable(),
  trellisSystem: yup.string().nullable(),
  pruningMethod: yup.string().nullable(),
  varietyID: yup
    .string()
    .required('Variety ID is required. Select the relevant Crop Type first'),
  rootStock: yup.string().nullable(),
});

export const BlockFormSchemaOut = yup.object({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Name is required'),
  ranchID: yup.string().required('Ranch ID is required'),
  acres: yup.number().positive('Acres must be a positive number').nullable(),
  fromDate: yup.string().nullable(),
  thruDate: yup.string().nullable(),
  plantSpacing: yup
    .number()
    .positive('Plant spacing must be a positive number')
    .max(
      MAX_PLANT_SPACING,
      `Plant spacing must be less than ${MAX_PLANT_SPACING}`
    )
    .nullable(),
  rowSpacing: yup
    .number()
    .positive('Row spacing must be a positive number')
    .max(MAX_ROW_SPACING, `Row spacing must be less than ${MAX_ROW_SPACING}`)
    .nullable(),
  trellisSystem: yup.string().nullable(),
  pruningMethod: yup.string().nullable(),
  cropType: yup
    .string()
    .oneOf(Object.values(CropTypes), 'Invalid crop type')
    .required('Crop type is required'),
  varietyID: yup
    .string()
    .required(
      'Variety is required. Select the relevant Crop Type and then the variety'
    ),
  rootStock: yup.string().nullable(),
});

export const BlockValidationSchema = yup.object({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Name is required'),
  ranchID: yup.string().required('Ranch ID is required'),
  acres: yup.number().positive('Acres must be a positive number').nullable(),
  fromDate: yup.string().nullable(),
  thruDate: yup.string().nullable(),
  plantSpacing: yup
    .number()
    .positive('Plant spacing must be a positive number')
    .max(
      MAX_PLANT_SPACING,
      `Plant spacing must be less than ${MAX_PLANT_SPACING}`
    )
    .nullable(),
  rowSpacing: yup
    .number()
    .positive('Row spacing must be a positive number')
    .max(MAX_ROW_SPACING, `Row spacing must be less than ${MAX_ROW_SPACING}`)
    .nullable(),
  trellisSystem: yup.string().nullable(),
  pruningMethod: yup.string().nullable(),
  varietyID: yup
    .string()
    .required(
      'Variety is required. Select the relevant Crop Type and then the variety'
    ),
  rootStock: yup.string().nullable(),
});
